// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"28087457","787":"e8fbd3bd"}[chunkId] + ".chunk.js";
};